/* eslint-disable react/jsx-filename-extension */
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import { ThemeProvider } from "@material-ui/core/styles";
import { UserContextProvider } from 'context/UserContext';
import theme from "./theme";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./icons/style.css";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <UserContextProvider>
          <App />
        </UserContextProvider>
      </Router>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
